"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/design-system/utils/cn";
import { FormattedTitle } from "~/components/job-page/ad/formatted-title-eon";
import PrivacyNotice from "~/components/job-page/jobadtemplate/privacy-notice-eon";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
export default function JobAdTemplateHungary(t0) {
  const $ = _c(35);
  const {
    job
  } = t0;
  const t = useLanguage();
  const {
    data,
    content
  } = job;
  let t1;
  if ($[0] !== content.hungaryAddress || $[1] !== data.locations) {
    t1 = content.hungaryAddress?.length ? content.hungaryAddress : [...new Set((data.locations ?? []).map(_temp).filter(Boolean))];
    $[0] = content.hungaryAddress;
    $[1] = data.locations;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const addresses = t1;
  let t2;
  if ($[3] !== data.title) {
    t2 = <h2 className="mb-4 font-bold text-4xl text-primary md:text-5xl"><FormattedTitle input={data.title} /></h2>;
    $[3] = data.title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("text-clientFont md:text-lg", "print:break-inside-auto print:text-black", "overflow-wrap-break-word", "[&_p+p]:mt-4", "[&_p:not(li>p)]:mb-4 [&_p:not(li>p)]:print:my-0 [&_p:not(li>p)]:print:mb-0 [&_p:not(li>p)]:print:p-0", "[&_h1]:mb-4 [&_h1]:print:my-0 [&_h1]:print:mb-0 [&_h1]:print:p-0", "[&_h2]:mb-4 [&_h2]:print:my-0 [&_h2]:print:mb-0 [&_h2]:print:p-0", "[&_h3]:mb-4 [&_h3]:print:my-0 [&_h3]:print:mb-0 [&_h3]:print:p-0", "[&_li]:mb-1.5", "[&_ul]:mt-4 [&_ul]:mb-8 [&_ul]:ml-6 [&_ul]:list-disc [&_ul]:print:my-0 [&_ul]:print:py-0");
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== content.task || $[7] !== content.taskHL) {
    t4 = content.task && <div className="mt-6">{content.taskHL && <h3 className="font-bold" data-source="job">{content.taskHL}</h3>}<div dangerouslySetInnerHTML={{
        __html: content.task
      }} data-source="job" /></div>;
    $[6] = content.task;
    $[7] = content.taskHL;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== content.profile || $[10] !== content.profileHL) {
    t5 = content.profile && <div className="mt-6">{content.profileHL && <h3 className="font-bold" data-source="job">{content.profileHL}</h3>}<div dangerouslySetInnerHTML={{
        __html: content.profile
      }} data-source="job" /></div>;
    $[9] = content.profile;
    $[10] = content.profileHL;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== content.offer || $[13] !== content.offerHL) {
    t6 = content.offer && <div className="mt-6">{content.offerHL && <h3 className="font-bold" data-source="job">{content.offerHL}</h3>}<div dangerouslySetInnerHTML={{
        __html: content.offer
      }} data-source="job" /></div>;
    $[12] = content.offer;
    $[13] = content.offerHL;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== addresses || $[16] !== t.jobad_locationDisplay_single) {
    t7 = addresses.length > 0 && <div><span className="font-bold text-lg">{t.jobad_locationDisplay_single}:{" "}</span>{addresses.map((address, index) => <span key={address}>{address}{index < addresses.length - 1 && " vagy "}</span>)}</div>;
    $[15] = addresses;
    $[16] = t.jobad_locationDisplay_single;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t.jobad_inclusionHL) {
    t8 = <p className="mt-8 font-bold" data-source="lc">{t.jobad_inclusionHL}</p>;
    $[18] = t.jobad_inclusionHL;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t.jobad_inclusion_text) {
    t9 = <p data-source="lc">{t.jobad_inclusion_text}</p>;
    $[20] = t.jobad_inclusion_text;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t8 || $[23] !== t9) {
    t10 = <div>{t8}{t9}</div>;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <PrivacyNotice className="mt-8" />;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t4 || $[28] !== t5 || $[29] !== t6 || $[30] !== t7) {
    t12 = <div className={t3}>{t4}{t5}{t6}{t7}{t10}{t11}</div>;
    $[26] = t10;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t12 || $[33] !== t2) {
    t13 = <section className="grid w-full justify-center py-8 print:hidden" id="job"><div className="mx-6 max-w-screen-xl md:mx-10">{t2}{t12}</div></section>;
    $[32] = t12;
    $[33] = t2;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  return t13;
}
function _temp(location) {
  return location.city;
}